module.exports = __webpack_public_path__ + "img/发票示例1.b51462a5.png";